import React, { SVGProps } from 'react';

export const Team2SVG = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <g clipPath='url(#clip0_3366_12400)'>
      <path
        d='M9.22947 12.5101H8.6828C8.60895 12.5086 8.53869 12.478 8.48744 12.4248C8.43619 12.3716 8.40815 12.3002 8.40947 12.2264V3.36325C8.40882 3.32671 8.41537 3.2904 8.42875 3.25639C8.44214 3.22238 8.46209 3.19134 8.48747 3.16504C8.51286 3.13875 8.54317 3.11771 8.57669 3.10313C8.6102 3.08855 8.64626 3.08072 8.6828 3.08008H9.22947'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M7.17944 8H8.40944' stroke='#252F3F' strokeWidth='0.88' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M10.8694 3.0801C10.8694 3.24162 10.9012 3.40157 10.963 3.5508C11.0248 3.70003 11.1154 3.83562 11.2296 3.94984C11.3439 4.06406 11.4795 4.15466 11.6287 4.21647C11.7779 4.27828 11.9379 4.3101 12.0994 4.3101C12.2609 4.3101 12.4209 4.27828 12.5701 4.21647C12.7193 4.15466 12.8549 4.06406 12.9691 3.94984C13.0833 3.83562 13.1739 3.70003 13.2358 3.5508C13.2976 3.40157 13.3294 3.24162 13.3294 3.0801C13.3294 2.91857 13.2976 2.75863 13.2358 2.6094C13.1739 2.46017 13.0833 2.32457 12.9691 2.21036C12.8549 2.09614 12.7193 2.00554 12.5701 1.94373C12.4209 1.88191 12.2609 1.8501 12.0994 1.8501C11.9379 1.8501 11.7779 1.88191 11.6287 1.94373C11.4795 2.00554 11.3439 2.09614 11.2296 2.21036C11.1154 2.32457 11.0248 2.46017 10.963 2.6094C10.9012 2.75863 10.8694 2.91857 10.8694 3.0801Z'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.1495 6.35997C14.0277 5.90365 13.763 5.49829 13.3943 5.20319C13.0255 4.9081 12.572 4.73877 12.1 4.71997C11.628 4.73865 11.1744 4.90794 10.8055 5.20304C10.4366 5.49814 10.1719 5.90356 10.05 6.35997H14.1495Z'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.8694 10.8699C10.8694 11.0314 10.9012 11.1914 10.963 11.3406C11.0248 11.4898 11.1154 11.6254 11.2296 11.7396C11.3439 11.8539 11.4795 11.9445 11.6287 12.0063C11.7779 12.0681 11.9379 12.0999 12.0994 12.0999C12.2609 12.0999 12.4209 12.0681 12.5701 12.0063C12.7193 11.9445 12.8549 11.8539 12.9691 11.7396C13.0833 11.6254 13.1739 11.4898 13.2358 11.3406C13.2976 11.1914 13.3294 11.0314 13.3294 10.8699C13.3294 10.7084 13.2976 10.5484 13.2358 10.3992C13.1739 10.25 13.0833 10.1144 12.9691 10.0002C12.8549 9.88594 12.7193 9.79533 12.5701 9.73352C12.4209 9.67171 12.2609 9.63989 12.0994 9.63989C11.9379 9.63989 11.7779 9.67171 11.6287 9.73352C11.4795 9.79533 11.3439 9.88594 11.2296 10.0002C11.1154 10.1144 11.0248 10.25 10.963 10.3992C10.9012 10.5484 10.8694 10.7084 10.8694 10.8699Z'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M14.1496 14.15C14.0277 13.6936 13.763 13.2882 13.3941 12.9931C13.0252 12.698 12.5716 12.5287 12.0996 12.51C11.6275 12.5287 11.1739 12.698 10.805 12.9931C10.4361 13.2882 10.1714 13.6936 10.0496 14.15H14.1496Z'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M2.66943 6.35997C2.66943 6.79493 2.84222 7.21207 3.14978 7.51963C3.45734 7.82719 3.87448 7.99997 4.30943 7.99997C4.74439 7.99997 5.16153 7.82719 5.46909 7.51963C5.77665 7.21207 5.94943 6.79493 5.94943 6.35997C5.94943 5.92502 5.77665 5.50788 5.46909 5.20032C5.16153 4.89276 4.74439 4.71997 4.30943 4.71997C3.87448 4.71997 3.45734 4.89276 3.14978 5.20032C2.84222 5.50788 2.66943 5.92502 2.66943 6.35997Z'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M1.84937 11.2801C1.84937 10.6276 2.10854 10.0019 2.56988 9.54059C3.03122 9.07925 3.65693 8.82007 4.30937 8.82007C4.9618 8.82007 5.58751 9.07925 6.04885 9.54059C6.51019 10.0019 6.76937 10.6276 6.76937 11.2801H1.84937Z'
        stroke='#252F3F'
        strokeWidth='0.88'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </g>
    <defs>
      <clipPath id='clip0_3366_12400'>
        <rect width='14' height='14' fill='white' transform='translate(1 1)' />
      </clipPath>
    </defs>
  </svg>
);
